// @ts-nocheck

import styled, { css } from 'styled-components'
import { ReactComponent as ClockFile } from '../../../../../../assets/icons/clock.svg'

export const ClockIcon = styled(ClockFile)`
  ${({ theme }) => css`
    fill: #39383a;
    margin-right: ${theme.spacing.inline.xxxs};
    @media (max-width: 767px) {
      fill: white;
      min-height: 24px;
      min-width: 24px;
    }
    @media (min-width: 768px) {
      min-height: 32px;
      min-width: 32px;
    }
  `}
`
export const Container = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 767px) {
    .textInfo {
      color: white;
    }
  }
`

export const SingleDateBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
  `}
`
